import { render, staticRenderFns } from "./FolderCreate.vue?vue&type=template&id=6445986e&scoped=true&"
import script from "./FolderCreate.vue?vue&type=script&lang=js&"
export * from "./FolderCreate.vue?vue&type=script&lang=js&"
import style0 from "./FolderCreate.vue?vue&type=style&index=0&id=6445986e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6445986e",
  null
  
)

export default component.exports